import React, { useState, useEffect, useContext} from 'react';
import { IComponentCode } from '../../component.d';
import { direct } from '../../utils/image';
import { ThemeContext } from "../../store/ThemeProvider";
import { inject, observer } from "mobx-react";

const AllForCode = (props: IComponentCode) => {
  const { cid, js, css} = props;
  const { uiStore, commonStore, galleryStore, wxuserStore, localeStore} = props.rootStore!;
  const { mainColor, h1Color, backgroundColor, componentColor, setTheme} =
    useContext(ThemeContext);

  const onScriptLoaded = () => {
    // @ts-ignore
    if (typeof window[`code_${cid}`] == 'function') {
      try {
        // @ts-ignore
        window[`code_${cid}`](cid, {
          setTheme,
          showToast:uiStore.showToast,
          hideToast:uiStore.hideToast,
          uploadImage:commonStore.uploadImage,
          insertImage:galleryStore.uploadImage,
          isLogin:wxuserStore.user.is_mock,
          auth:wxuserStore.auth,
          locale:localeStore.locale,
          setLocale:localeStore.setLocale,
          reloadLocale:localeStore.reloadLocale
        });
      } catch (e) {
        console.error(props, e);
      }
    }
  };

  useEffect(() => {
    if (js) {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = direct(js);
      script.charset = 'utf-8';
      script.onload = onScriptLoaded;
      document.body.appendChild(script);
    }
  }, [js]);

  useEffect(() => {
    if (css) {
      let link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.href = direct(css);
      document.head.appendChild(link);
    }
  }, [css]);

  return <div className={`code_${cid}`} key={cid} id={cid}></div>;
};

export default inject('rootStore')(observer(AllForCode));
